import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../../notification.service';
import { RestService } from '../../rest.service';

@Component({
  selector: 'forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
})
export class ForgetPasswordComponent implements OnInit {
  loginFormGroup: FormGroup;
  submitted: boolean = false;
  result: boolean;

  constructor(private formBuilder: FormBuilder, private restService:RestService, private router: Router,
     private notify: NotificationService , private spinner: NgxSpinnerService) {

    this.loginFormGroup = this.formBuilder.group({
    emailId:['', [Validators.required, Validators.email]],
  });
  }
  get emailId() { return this.loginFormGroup.get('emailId') }

  ngOnInit() {
  }

  getLink() {
    this.submitted = true;
    let param =  'SendResetLink' ;
    this.spinner.show();
    this.restService.postModel(this.loginFormGroup.value, `/screen/forgotPassword/${param}`).subscribe((response) => {
      this.result = response;
      if (response) {
        this.notify.showSuccess('Reset Link Sent', 'success');
        this.router.navigateByUrl('/login');
      } else {
        this.notify.showError('Sent Reset Link Failed!', '')
      }
      this.spinner.hide();
    });
  }

}
